<template>
  <div class="container" v-if="$route.name!='maintenance'">

    <div class="columns is-multiline" v-if="$route.path.indexOf('/cms')">

      <div class="column is-6">
        <img src="../assets/Martin-Jauschneg-Karte.png">
      </div>

      <div class="column is-6 is-size-5 is-size-7-mobile">
        <p class="has-text-weight-bold has-text-primary" style="margin-bottom:10px;">DI<sup>in</sup> Martina Jauschneg Ingenieurbüro</p>
        <p style="margin-bottom:10px;">Franz-Josefs-Kai 27<br>
1010 Wien, Österreich</p>
        <p style="margin-bottom:10px;">Oberfahrenbach 92<br>
8452 Großklein, Österreich</p>
<p><a href="tel:+436508114894"><span class="icon"><i class="fa fa-phone"></i></span>&nbsp;&nbsp;<span>+43 650 811 48 94</span></a><br>
<a :href="'mailto:' + contact"><span class="icon"><i class="fa fa-envelope-o"></i></span>&nbsp;&nbsp;<span>{{ contact }}</span></a><br>
<a href="https://www.linkedin.com/in/martina-jauschneg-0a751212/" target="_blank"><span class="icon"><i class="fa fa-linkedin"></i></span>&nbsp;&nbsp;<span>LinkedIn</span></a><br>
<a href="https://www.xing.com/profile/Martina_Jauschneg" target="_blank"><span class="icon"><i class="fa fa-xing"></i></span>&nbsp;&nbsp;<span>Xing</span></a></p>

      </div>
    </div>

 <div class="columns is-multiline">
      <div class="column is-12 is-size-7-mobile">
            <router-link :to="isGerman ? '/impressum' : '/imprint'">{{ isGerman ? 'Impressum' : 'Imprint' }}</router-link> © DI<sup>in</sup> Martina Jauschneg, Ingenieurbüro Beratende Ingenieurin für Landschaftsplanung
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    contact () {
      return this.$store.getters.contact
    },
    isGerman () {
      return this.$store.getters.isGerman
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue